export enum ETypeModifSeance {
  Heure = 'heure',
  Date = 'date',
  Infirmier = 'infirmier',
	Actes = 'actes'

}